  import React from "react";
  import { Navigate } from "react-router-dom";

  // estaLogado: boolean
  // tipoNecessario: "passenger" | "driver" | undefined (qualquer logado serve)
  const ProtectedRoute = ({ children, estaLogado, tipoNecessario }) => {
    if (!estaLogado) {
      return <Navigate to="/login" replace />;
    }

    if (tipoNecessario) {
      const tipoAtual = localStorage.getItem("userType");
      if (tipoAtual !== tipoNecessario) {
        // Redireciona para a home correta se tentou acessar rota errada
        if (tipoAtual === "driver") return <Navigate to="/driver-home" replace />;
        return <Navigate to="/passenger-home" replace />;
      }
    }

    return children;
  };

  export default ProtectedRoute;